import { render, staticRenderFns } from "./QuestionarioCentroDiagnostico.vue?vue&type=template&id=7406ccb6&scoped=true"
import script from "./QuestionarioCentroDiagnostico.vue?vue&type=script&lang=js"
export * from "./QuestionarioCentroDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioCentroDiagnostico.vue?vue&type=style&index=0&id=7406ccb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406ccb6",
  null
  
)

export default component.exports